export const URLAPISUBIDA = 'https://grupoburaz.com/apisubida/subirimg.php'
export const URLCARPETADESTINO = 'https://grupoburaz.com/apisubida/'